import * as React from "react";
import {Async} from 'react-select';
import {none, option, Option} from "ts-option";
import {ActionMeta} from "react-select/lib/types";
import {PartnerBrandSearch} from "../../../model/partnerBrand/PartnerBrand";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {api} from "../../../api/api";
import {DisableableProps} from "../../common/props/DisableableProps";
import {ClearableProps} from "../../common/props/ClearableProps";

interface ComponentProps {
	/**
	 * Callback on select partner brand.
	 * @param {PartnerBrandSearch} material.
	 */
	onSelect: (partnerBrand: Option<PartnerBrandSearch>) => void;
	/**
	 * Brand id
	 */
	brandId?: string
	/**
	 * Selected partner brand
	 */
	selectedValue: Option<PartnerBrandSearch>
	/**
	 *  Support multiple selected options
	 */
	isMulti?: boolean;
}

type Props = ComponentProps & PlaceholderProps & DisableableProps & ClearableProps;

const minCharsToSearch = 2;

export default class PartnerBrandSelectionComponent extends React.PureComponent<Props> {

	render() {
		return (
			<Async className={"c-select-component"}
				   classNamePrefix={"c-select-component"}
				   cacheOptions={false}
				   loadOptions={this.findBySearchText}
				   defaultOptions={true}
				   getOptionLabel={(pb: PartnerBrandSearch) => pb.name}
				   isClearable={this.props.clearable}
				   onChange={this.onSelected}
				   noOptionsMessage={this.onOptionMessage}
				   value={this.props.selectedValue.orNull}
				   isDisabled={this.props.disabled}
				   placeholder={this.props.placeholder}
				   isMulti={this.props.isMulti}
			/>
		)
	}

	onOptionMessage = (obj: { inputValue: string }) => {
		if (obj.inputValue.length < minCharsToSearch)
			return "Type to search";
		else
			return "No results found"
	}

	/**
	 * Callback on selected item.
	 * @param {PartnerBrandSearch} selected item.
	 * @param {ActionMeta} actionMeta performed action data.
	 */
	onSelected = (selected: PartnerBrandSearch, actionMeta: ActionMeta) => {
		if (actionMeta.action === 'clear') {
			this.props.onSelect(none)
		}
		// compare with array is fix for https://github.com/JedWatson/react-select/issues/2682
		else if (!(selected instanceof Array)) {
			this.props.onSelect(option(selected));
			api.instance.partnerBrandApi.clearCache()
		}
	}

	/**
	 * Fetch partner brands by search text.
	 * @param {string} searchText text to search by.
	 * @param callback
	 */
	private findBySearchText = (searchText: string, callback: (result: PartnerBrandSearch[]) => void) => {
		if (searchText.length >= minCharsToSearch) {
			api.instance.partnerBrandApi.findPartnerBrandsByText(searchText, this.props.brandId)
				.then(callback)
				.catch((error) => {
					callback([])
					notifyBugsnagAndShowToast(error, "Error on searching partner brands");
				});
		}
		else (
			callback([])
		)
	}
}
